import { useState } from "react";
import {
  adminInvitePartner,
} from "../../../../api/apiEndpoints";
import {
  SectionTitle, Card, Row, Input, Button, StatusText,
} from "../styles";

const InvitesPage = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<{ msg: string; ok: boolean } | null>(null);
  const [loading, setLoading] = useState(false);

  const handleInvite = async () => {
    if (!email) return;
    setLoading(true);
    setStatus(null);
    try {
      const res = await adminInvitePartner(email);
      setStatus({ msg: `Invite sent to ${email}. Link: ${(res.data as any).emailText?.split(": ").pop() || "sent"}`, ok: true });
      setEmail("");
    } catch (e: any) {
      setStatus({ msg: e?.response?.data?.message || "Failed to send invite.", ok: false });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <SectionTitle>Send Partner Onboarding Link</SectionTitle>
      <p style={{ fontSize: 13, color: "#555", marginTop: 0, marginBottom: 20 }}>
        Sends a 10-day signup link to a new gym partner's email address.
      </p>
      <Row>
        <Input
          placeholder="partner@gym.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          style={{ flex: 1 }}
        />
        <Button onClick={handleInvite} disabled={!email || loading}>
          {loading ? "Sending…" : "Send Invite"}
        </Button>
      </Row>
      {status && <StatusText success={status.ok}>{status.msg}</StatusText>}
    </Card>
  );
};

export default InvitesPage;
